<template>
  <div class='rkld'>
    <div class='rkldRight'>
      <div class='rkldRightContent'>
        <el-tabs
          v-model='editableTabsValue'
          type='card'
          @edit='handleTabsEdit'
        >
          <el-tab-pane label='固定资产' name='1'>
            <!--查询条件-->
            <div class='searchTj'>
              <div class='searchTjHead'>
                <span>查询条件</span>
                <i class="searchDomw" @click="showSearch = !showSearch" :class="showSearch==true?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                <!-- <el-button
                  style='
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    '
                  type='text'
                  @click='Reset'
                >
                  <i class='el-icon-refresh'></i>
                  刷新页面 -->
                </el-button>
              </div>
              <el-form :model='form' class='searchTjContent' v-show='showSearch'>
                <div
                  class='searchTjContentDiv'
                >
                                    <span class='searchTjContentDivSpan'
                                    >设备名称</span
                                    >
                  <el-input
                    v-model='form.deviceName'
                    placeholder='请输入'
                    class='searchTjContentDivInput'
                  ></el-input>
                </div>
                <div
                  class='searchTjContentDiv'
                  v-show='quanbu'
                >
                  <el-button
                    type='primary'
                    @click='query'
                    class="searchBtns"
                    icon='el-icon-search'
                  >查询
                  </el-button
                  >
                </div>

                <div
                  class='searchTjContentDiv'
                >
                  <el-button
                    type='info'
                    icon='el-icon-delete'
                    @click='resert'
                  >清除条件
                  </el-button
                  >
                </div>
                <div class='arrowDown' @click='showSearch'>
                  <i
                    class='el-icon-arrow-down'
                    style='color: #000'
                  ></i>
                </div>
              </el-form>
            </div>

            <!--按钮-->
            <div class='searchButtonDiv' v-if='quanbu'>
              <div class='searchButtonDivLeft'>
                <el-button-group>
                  <el-button
                    icon='el-icon-plus'
                    type='success'
                    class="openBtns"
                    @click="showDialog('新增')"
                  >新增
                  </el-button
                  >
                  <el-button
                    icon='el-icon-delete'
                    type='danger'
                    @click='batchDelete'
                  >批量删除
                  </el-button
                  >
                  <el-button type='primary' @click='show'
                  >设备管理类型
                  </el-button
                  >
                </el-button-group>
              </div>
              <div class='searchButtonDiveRight'>
                <el-button-group>
                  <el-button
                    type='primary'
                    icon='el-icon-refresh'
                    class="dropRests"
                    @click='resertTable'
                  ></el-button>
                  <!-- <el-button type="primary"> -->
                  <el-dropdown
                    class='dropdown'
                    trigger='click'
                    :hide-on-click='false'
                  >
                                        <span class='el-dropdown-link'>
                                            <i
                                              class='el-icon-s-grid el-icon--right'
                                              style='color: #fff'
                                            ></i>
                                            <i
                                              class='el-icon-arrow-down el-icon--right'
                                            ></i>
                                        </span>
                    <el-dropdown-menu slot='dropdown'>
                      <el-dropdown-item>
                        <template>
                          <el-checkbox-group
                            v-model='checkList'
                            :min='1'
                            @change='tableShow'
                          >
                            <el-checkbox
                              label='序号'
                            >序号
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='设备名称'
                            >设备名称
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='设备型号'
                            >设备型号
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='设备类型'
                            >设备类型
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='数量'
                            >数量
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='保管人'
                            >保管人
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='生产厂家'
                            >生产厂家
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='操作'
                            >操作
                            </el-checkbox
                            >
                            <br />
                          </el-checkbox-group>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- </el-button> -->
                </el-button-group>
              </div>
            </div>

            <!--表格-->
            <div>
              <el-table
                ref='multipleTable'
                :data='myData'
                tooltip-effect='dark'
                @row-click='openDetails'
                highlight-current-row
                @selection-change='handleSelectionChange'
                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                border
              >
                <el-table-column
                  type='selection'
                  width='50'
                  align='center'
                  @selection-change='handleSelectionChange'
                >
                </el-table-column>
                <el-table-column
                  type='index'
                  width='70'
                  label='序号'
                  header-align='center'
                  align='center'
                  v-if='no1'
                ></el-table-column>
                <el-table-column
                  prop='deviceName'
                  label='设备名称'
                  align='center'
                  v-if='no2'
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop='deviceModel'
                  label='设备型号'
                  align='center'
                  show-overflow-tooltip
                  v-if='no3'
                >
                </el-table-column>
                <el-table-column
                  prop='deviceTypeName'
                  label='设备类型'
                  align='center'
                  show-overflow-tooltip
                  v-if='no4'
                >
                </el-table-column>
                <el-table-column
                  prop='deviceNum'
                  label='数量'
                  align='center'
                  show-overflow-tooltip
                  v-if='no5'
                >
                </el-table-column>
                <el-table-column
                  prop='deviceCustodian'
                  label='保管人'
                  align='center'
                  show-overflow-tooltip
                  v-if='no6'
                >
                </el-table-column>
                <el-table-column
                  prop='deviceFactory'
                  label='生产厂家'
                  align='center'
                  show-overflow-tooltip
                  v-if='no7'
                >
                </el-table-column>
                <el-table-column
                  prop='operation'
                  label='操作'
                  align='center'
                  width='230'
                  v-if='no8'
                >
                  <template slot-scope='scope'>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='查看'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-chakan tabBtn'
                        @click="
                                                    showDialog(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='编辑'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-bianji3 tabBtn'
                        @click="
                                                    showDialog(
                                                        '编辑',
                                                        scope.row
                                                    )
                                                "
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='删除'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-icon7 tabBtn'
                        @click='deleteItem(scope.row)'
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page='currentPage'
                :page-sizes='[10, 20, 50, 100]'
                :page-size='10'
                layout='total, sizes, prev, pager, next, jumper'
                :total='total1'
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog :title='dialogTile' :visible.sync='visVisible' width='990px'>
      <el-form
        ref='addform'
        :model='addform'
        :rules='addformRules'
        label-width='140px'
        size='mini'
      >
        <el-form-item label='设备名称：' prop='deviceName'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.deviceName'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='设备型号：' prop='deviceModel'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.deviceModel'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item
          label='设备类型：'
          prop='deviceTypeId'
          @change.native='type'
        >
          <el-select
            v-model='addform.deviceTypeId'
            placeholder='请选择'
            style='width: 100%'
            :disabled="dialogTile == '查看'"
          >
            <el-option
              v-for='(item, index) in options'
              :key='index'
              :label='item.deviceTypeName'
              :value='item.id'
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='数量：' prop='deviceNum'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.deviceNum'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item
          label='保管人：'
          prop='deviceCustodian'
          @change.native='type'
        >
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.deviceCustodian'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='生产厂家：' prop='deviceFactory'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.deviceFactory'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='采购期：' prop='purchaseTime'>
          <el-date-picker
            :disabled="dialogTile == '查看'"
            v-model='addform.purchaseTime'
            type='date'
            placeholder='选择日期'
            value-format='yyyy-MM-dd HH:mm:ss'
            style='width: 100%'
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label='质保期：' prop='warrantyTime'>
          <el-date-picker
            :disabled="dialogTile == '查看'"
            v-model='addform.warrantyTime'
            type='date'
            placeholder='选择日期'
            value-format='yyyy-MM-dd HH:mm:ss'
            style='width: 100%'
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label='维修人：' prop='repairMan'>
          <el-input
            v-model='addform.repairMan'
            placeholder='请输入'
            :disabled="dialogTile == '查看'"
          ></el-input>
        </el-form-item>
        <el-form-item label='维修人联系方式：' prop='repairPhone'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.repairPhone'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item
          label='是否入库：'
          prop='deviceStates'
          v-if="dialogTile != '查看'"
        >
          <el-radio
            v-model='addform.deviceStates'
            label='0'
            :disabled="dialogTile == '查看'"
          >是
          </el-radio
          >
          <el-radio
            v-model='addform.deviceStates'
            label='1'
            :disabled="dialogTile == '查看'"
          >否
          </el-radio
          >
        </el-form-item>
      </el-form>
      <div slot='footer' v-if="dialogTile != '查看'">
        <el-button
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click='saveadddata'
        >保存
        </el-button>
        <el-button type='info' size='small' @click='clearadddata'
        >关闭
        </el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title='设备管理类型'
      :visible.sync='visVisible1'
      width='990px'
    >
      <el-form
        ref='deviceForm'
        :model='deviceForm'
        label-width='110px'
        size='mini'
      >
        <el-form-item
          label='名称：'
          prop='deviceTypeName'
          :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                    }"
        >
          <el-input
            v-model='deviceForm.deviceTypeName'
            placeholder='请输入'
            style='width: 100%'
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        class='boontbtn'
        style='
                    display: flex;
                    justify-content: center;
                    align-items: center;
                '
      >
        <el-button
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click='saveType'
        >保存
        </el-button>
        <el-button type='info' size='small' @click='visVisible1 = false'
        >关闭
        </el-button
        >
      </div>
      <el-table
        :data='deviceForm'
        tooltip-effect='dark'
        style='width: 100%;margin-top:20px'
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column
          type='index'
          label='序号'
          width='150'
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop='deviceTypeName'
          label='名称'
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop='operation'
          label='操作'
          align='center'
          width='230'
        >
          <template slot-scope='scope'>
            <el-tooltip
              class='item'
              effect='dark'
              content='修改'
              placement='top-start'
            >
              <button
                style='color: #000'
                class='iconfont icon-bianji3 tabBtn'
                @click="showtype('修改', scope.row)"
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='dark'
              content='删除'
              placement='top-start'
            >
              <button
                style='color: red'
                class='iconfont icon-icon7 tabBtn'
                @click='clearType(scope.row)'
              ></button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='currentPage'
        :page-sizes='[10, 20, 50, 100]'
        :page-size='10'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
      ></el-pagination>
    </el-dialog>

    <!-- 修改type -->
    <el-dialog title='修改' :visible.sync='visVisibletype' width='990px'>
      <el-form :model='updateDevice' ref='updateDevice'>
        <el-form-item label='名称：' prop='deviceTypeName'>
          <el-input
            v-model='updateDevice.deviceTypeName'
            placeholder='请输入'
            style='width: 80%'
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer'>
        <el-button
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click.native='updateType'
        >保存
        </el-button>
        <el-button
          type='info'
          size='small'
          @click='visVisibletype = false'
        >关闭
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request.js'
import { conflictMediationApi2 } from '@/api/http.js'
import request2 from '@/utils/request2.js'
import { post, get } from '@/api/requrestHttp.js'

export default {
  data() {
    return {
      // 表单验证
      addformRules: {
        deviceName: [
          {
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
          }
        ],
        deviceModel: [
          {
            required: true,
            message: '请输入设备型号',
            trigger: 'blur'
          }
        ],
        deviceTypeId: [
          {
            required: true,
            message: '请输入设备类型',
            trigger: 'change'
          }
        ],
        // deviceTypeName: [
        //     {
        //         required: true,
        //         message: "请输入设备类型",
        //         trigger: "change",
        //     },
        // ],
        deviceNum: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        deviceCustodian: [
          {
            required: true,
            message: '请输入保管人',
            trigger: 'blur'
          }
        ],
        deviceFactory: [
          {
            required: true,
            message: '请输入生产厂家',
            trigger: 'blur'
          }
        ],
        purchaseTime: [
          {
            required: true,
            message: '请输入采购期',
            trigger: 'change'
          }
        ],
        warrantyTime: [
          {
            required: true,
            message: '请输入质保期',
            trigger: 'change'
          }
        ],
        repairMan: [
          {
            required: true,
            message: '请输入维修人姓名',
            trigger: 'blur'
          }
        ],
        repairPhone: [
          {
            required: true,
            message: '请输入维修人联系方式',
            trigger: 'blur'
          }
        ],
        deviceStates: [
          {
            required: true,
            message: '请选择是否入库',
            trigger: 'change'
          }
        ]
      },
      formRules: {
        deviceTypeName: [
          {
            required: true,
            message: '请输入设备类型',
            trigger: 'change'
          }
        ]
      },
      selectedData: [],
      options: [],
      // 图片地址
      actionUrl: '',
      visVisible: false,
      visVisible1: false,
      visVisibletype: false,
      // 图片
      photo: [],
      addform: {
        deviceName: '',
        deviceModel: '',
        deviceTypeId: '',
        deviceTypeName: '',
        deviceNum: '',
        deviceCustodian: '',
        deviceFactory: '',
        purchaseTime: '',
        warrantyTime: '',
        repairMan: '',
        repairPhone: '',
        deviceStates: ''
      },
      checkList: [
        '序号',
        '设备名称',
        '设备型号',
        '设备类型',
        '数量',
        '保管人',
        '生产厂家',
        '操作'
      ],
      quanbu: true,

      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      showSearch: true,
      editableTabsValue: '1',
      deviceForm: [{ deviceTypeName: '' }],
      updateDevice: [{ deviceTypeName: '' }],
      myData: [],
      pageNo: 1,
      pageSize: 10,
      pageConfig: {
        pageSize: 10,
        total: 0,
        total1: 0,
        pageNo: 1
      },
      total1: 0,
      form: {
        deviceName: '',
        pageNo: 1,
        pageSize: 10
      },
      dialogTile: '',
      dialogImageUrl: '',
      dialogVisible1: false,
      // 列表显示
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true,
      no8: true
    }
  },
  inject: ['reload'], //注入
  methods: {
    // 列表项显示
    tableShow() {
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == '序号') == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '设备名称') == -1
        ) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '设备型号') == -1
        ) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '设备类型') == -1
        ) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (this.checkList.findIndex((obj) => obj == '数量') == -1) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == '保管人') == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '生产厂家') == -1
        ) {
          this.no7 = false
        } else {
          this.no7 = true
        }
        if (this.checkList.findIndex((obj) => obj == '操作') == -1) {
          this.no8 = false
        } else {
          this.no8 = true
        }
      }
    },
    // 新增
    showDialog(type, date) {
      this.visVisible = true
      this.dialogTile = type
      this.resetForm('addform')
      switch (type) {
        case '新增':
          break
        case '查看':
          this.look(date)
          break
        case '编辑':
          this.look(date)
          break
      }
    },
    // 查看
    async look(date) {
      await request({
        url: '/sqyl/admin/device/info/findById',
        method: 'POST',
        data: { id: date.id }
      }).then((res) => {
        console.log(res)
        // this.pageConfig.total = res.content.count;
        this.addform = res.content
        // console.log(this.addform);
        // this.total = res.content.count;
      })
    },
    // 设备管理类型
    show() {
      this.visVisible1 = true
      this.resetForm('deviceForm')
      this.showType()
    },

    showType() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      request({
        url: '/sqyl/admin/deviceType/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        // console.log(res);
        if (res.content) {
          this.pageConfig.total = res.content.count
          this.deviceForm = res.content.list
          this.total = res.content.count
          this.options = res.content.list
        } else {
          this.pageConfig.total = 0
          this.deviceForm = []
          this.options = []
          this.total = 0
        }

      })
    },
    // 新增
    saveType() {
      this.$refs.deviceForm.validate((valid) => {
        if (valid) {
          let params = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            deviceTypeName: this.deviceForm.deviceTypeName,
            qujiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .qujiId,
            shengjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shengjiId,
            shijiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .shijiId,
            stationId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).stationId,
            shequjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shequjiId
          }
          params = Object.assign({}, params)
          request({
            url: '/sqyl/admin/deviceType/info/insert',
            method: 'POST',
            data: params
          }).then((res) => {
            // console.log(res);
            if ((res.code = 200)) {
              this.showType()
            }
          })
        }
      })
    },
    // 修改类型
    showtype(type, date) {
      this.visVisibletype = true
      console.log(date.id)
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      request({
        url: '/sqyl/admin/deviceType/info/findById',
        method: 'POST',
        data: params
      }).then((res) => {
        this.updateDevice = res.content
      })
    },
    // 更新
    updateType() {
      this.$refs.updateDevice.validate((valid) => {
        if (valid) {
          let params = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            ...this.updateDevice,
            qujiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .qujiId,
            shengjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shengjiId,
            shijiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .shijiId,
            stationId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).stationId,
            shequjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shequjiId
          }
          params = Object.assign({}, params)
          request({
            url: '/sqyl/admin/deviceType/info/insert',
            method: 'POST',
            data: params
          }).then((res) => {
            // console.log(res);
            if ((res.code = 200)) {
              this.visVisibletype = false
              this.showType()
            }
          })
        }
      })
    },

    // 删除
    clearType(date) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id
      }
      params = Object.assign({}, params)
      this.$confirm('确认永久删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/sqyl/admin/deviceType/info/deleteById',
          method: 'POST',
          data: params
        }).then((res) => {
          if ((res.code = 200)) {
            this.showType()
          }
        })
      })
    },

    clearadddata() {
      this.visVisible = false
    },
    // 保存
    saveadddata() {
      this.$refs.addform.validate((valid) => {
        if (valid) {
          let params = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            ...this.addform,
            qujiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .qujiId,
            shengjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shengjiId,
            shijiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .shijiId,
            stationId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).stationId,
            shequjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shequjiId
          }
          params = Object.assign({}, params)
          request({
            url: '/sqyl/admin/device/info/insert',
            method: 'POST',
            data: params
          }).then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.visVisible = false
            }
            this.showlist()
          })
        }
      })
    },

    // 行点击选中
    openDetails(row, event, column, cell) {
      this.$refs.multipleTable.toggleRowSelection(row)
      this.showtext = !this.showtext
      this.row = row
      this.column = column
    },
    handleSelectionChange(data) {
      this.selectedData = data
    },
    batchDelete() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.$confirm('确认永久删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            val.forEach(function(item, index) {
              request({
                url: '/sqyl/admin/device/info/deleteById',
                method: 'POST',
                data: { id: item.id }
              })
            })
          })
          .then(() => {
            this.showlist()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
      } else {
        this.$confirm('请选择要删除的项。', '提示')
      }
      this.$refs.multipleTable.clearSelection()
    },

    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.showlist()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: 'success'
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.showlist()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: 'success'
      })
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleTabsEdit(targetName, action) {
      this.showlist(e)
    },

    //设备列表
    async showlist(e) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/device/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        // this.pageConfig.total = res.content.count;
        this.myData = res.content.list
        this.total1 = res.content.count
      })
    },
    // 删除
    deleteItem(date) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id
      }
      params = Object.assign({}, params)
      this.$confirm('确认永久删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/sqyl/admin/device/info/deleteById',
          method: 'POST',
          data: params
        }).then((res) => {
          if ((res.code = 200)) {
            this.showlist()
          }
        })
      })
    },

    // 查询
    query() {
      post('/sqyl/admin/device/info/findList', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }).then((res) => {
        if (res.content != null) {
          this.myData = res.content.list
          this.total1 = res.content.count
        } else {
          this.myData = []
        }
      })
    },

    // 查询重置
    resert() {
      this.form.deviceName = ''
      this.showlist()
    },

    // 页面刷新
    Reset() {
      this.reload()
    },

    // 表单刷新
    resertTable() {
      this.showlist()
      this.checkList = [
        '序号',
        '设备名称',
        '设备型号',
        '设备类型',
        '数量',
        '保管人',
        '生产厂家',
        '操作'
      ]
      this.tableShow()
    },

    // 预览图片
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },
    // 类型选项
    type() {
      this.showType()
    },
    // 表单重置
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    }
  },
  created() {
    this.showlist()
    this.showType()
  }
}
</script>
<style lang='less' scoped>
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldLeft {
  width: 234px;
  height: 100%;
  background: #37404f;
}

.rkldLeftLogo {
  background-color: rgb(55, 64, 79);
  height: 68px;
  width: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.rkldLeftLogoImage {
  width: 39px;
  margin-left: 20px;
  margin-right: 10px;
}

.rkldLeftContent {
  height: calc(100% - 68px);
  overflow-y: auto;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 254px);
  background-color: #ffffff;
}

.rkldRightHead {
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  background-color: #ececec;
  height: 69px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mlIcon {
  height: 35px;
  width: 35px;
  font-size: 14px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}

.mlIcon:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
  display: none !important;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.bodymsg {
  width: 140px;
  height: 40px;
  background-color: #ffb404;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  margin-top: 20px;
  cursor: pointer;
}

.switchpage {
  display: inline-block;
  margin-bottom: 10px;
}

.activesiwtch {
  background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.rkldRightHeadRightLeft img {
  margin-right: 5px;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  margin:5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px)2s;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}

/deep/ .el-button {
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

.el-submenu /deep/ .el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .el-submenu__title {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
  border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
.el-tabs--card
> .el-tabs__header
/deep/
.el-tabs__item.is-active.is-closable {
  color: #0e2d5f;
}

/deep/ .el-menu .is-active {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .el-submenu {
  width: 234px !important;
}

/deep/ .el-menu-item:hover {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .tabBtn {
  margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
  background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}

/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

.mapleft {
  margin-left: 10px;
  width: 200px;
  height: 600px;
  border: 1px solid black;
  border-radius: 5px;
}

// 上传图片
/deep/ .avatar-uploader {
  border-radius: 5px;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
</style>
